export const maxAnsibleDeveloper = 1000;
export const minAnsibleDeveloper = 0;
export const defaultAnsibleDeveloper = 60;
export const maxAnsibleTask = 200000;
export const minAnsibleTask = 0;
export const defaultAnsibleTask = 12000;
export const maxNumberPerYear = 12;
export const minNumberPerYear = 0;
export const defaultNumberPerYear = 0;
export const tokenPerTask = 500;

// UT30 is an unique code to identify each widget in the BPPR ecosystem
export const UT30PA = '30AGF';
